import { Build } from '@stencil/core';
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';
import { Swiper } from 'swiper';

Swiper.use([Navigation, Pagination, Scrollbar]);

export function initializeSlider(el: HTMLElement, options: SwiperOptions): Swiper {
  if (!Build.isBrowser) {
    return;
  }

  function checkNavigation(swiper) {
    if (swiper.isBeginning && swiper.isEnd) {
      el.classList.add('hide-navigation');
    } else {
      el.classList.remove('hide-navigation');
    }
  }

  options.on = options.on || {};
  options.on.init = checkNavigation;
  options.on.resize = checkNavigation;
  return new Swiper(el.querySelector('.swiper-container') as HTMLElement, options);
}
